module.exports = __webpack_public_path__ + "img/back buttons quantity.5219821f.png";